import { Fragment, useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'react-bootstrap';
import { Divider, Flex } from 'theme-ui';
import { Button } from '@velove/design-system';
import { DeliveryStatusType } from '../../contexts/contextTypes';

// @ts-ignore
import IBoxen from '../../assets/images/IBoxen.svg';
import dayjs from 'dayjs';

interface LockerDeliveryContainerProps {
  isCustomerService: boolean;
}

const LockerDeliveryContainer = ({ isCustomerService }: LockerDeliveryContainerProps) => {
  const { t } = useTranslation();
  const { trackingDetails } = useContext(AppContext);

  const disableOpenLocker = isCustomerService || trackingDetails?.task?.status !== DeliveryStatusType.CONSUMER_COLLECTION;
  const lockerAddress = trackingDetails?.packageLocker
    ? `${trackingDetails.packageLocker.street}, ${trackingDetails.packageLocker.postalCode} ${trackingDetails.packageLocker.city}`
    : '';

  const handleOpenIBoxen = () => {
    const IBOXEN_DEEP_LINK = 'iboxenconsumer://'; //'com.iboxenconsumerapp://'; //'iboxen://'; //com.iboxen.consumerapp://
    const IBOXEN_IOS_APP_STORE = 'https://apps.apple.com/se/app/iboxen/id1553931951';
    const IBOXEN_ANDROID_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.iboxenconsumerapp';

    // Attempt to open the app
    window.location.href = IBOXEN_DEEP_LINK;

    // Fallback logic: if the app doesn't open within a seconds, go to the store
    setTimeout(() => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isIOS = /ipad|iphone|ipod/.test(userAgent);

      if (isIOS) {
        window.location.href = IBOXEN_IOS_APP_STORE;
      } else {
        window.location.href = IBOXEN_ANDROID_PLAY_STORE;
      }
    }, 1000);
  };

  if (trackingDetails?.task?.taskType !== 'LOCKER_DELIVERY') {
    return null;
  }

  return (
    <Fragment>
      <Container style={{ marginTop: 20, marginBottom: 20 }}>
        <Flex sx={{ mb: 2 }}>
          {trackingDetails?.task?.status === DeliveryStatusType.CONSUMER_COLLECTION
            ? t('lockerDeliveryReadyForPickup')
                .replace(/(##provider##)/, trackingDetails?.packageLocker?.provider || 'iBoxen')
                .replace(/(##lockerExpiresAt##)/, dayjs(trackingDetails?.task?.lockerExpiresAt || new Date()).format('YYYY-MM-DD, HH:mm'))
            : t('lockerDeliveryOnTheWayToLocker').replace(/(##provider##)/, trackingDetails?.packageLocker?.provider || 'iBoxen')}
        </Flex>
        <Flex sx={{ mb: 20 }}>{`${t('lockerAddress')}: ${lockerAddress}`}</Flex>
        <Row>
          <Flex className="iboxen-container">
            <Button
              className="iboxen-button"
              pt={'5px'}
              pb={'5px'}
              onClick={handleOpenIBoxen}
              disabled={disableOpenLocker}
              sx={{
                opacity: !disableOpenLocker ? 1 : 0.5
              }}
            >
              <img src={IBoxen} width={30} height={30} alt="IBoxen_logo" style={{ marginRight: 5 }} />
              {t('openIBoxenApp') || 'Open iBoxen App'}
            </Button>
          </Flex>
        </Row>
      </Container>
      <Divider style={{ marginTop: 20, marginBottom: 0 }} />
    </Fragment>
  );
};

export default LockerDeliveryContainer;
